import { Action, createReducer, on } from '@ngrx/store';

import { setAppliedDateFilterTypeAction } from '@app/store/actions/global.actions';
import * as flightsResultsActions from '@flight-results/store/actions/flights-results.actions';
import * as hotelsActions from '@hotels/hotel-results/store/actions/hotels.actions';
import * as packagesResultActions from '@packages/packages-result/store/actions/packages-result.actions';
import * as activitiesActions from '@activities/activities-results/store/actions/activities-results.actions';
import { DateWidgetType } from '@shared/magic-filter-bar/date-filter/entities/date-filter';

export const initialState = null;

const featureReducer = createReducer(
  initialState,
  on(
    packagesResultActions.searchPackageAction,
    hotelsActions.searchHotelsAction,
    flightsResultsActions.searchFlightsAction,
    activitiesActions.fetchActivitiesResultsAction,
    () => initialState
  ),
  on(setAppliedDateFilterTypeAction, (state, { payload }) => payload),
);

export const appliedDateFilterTypeReducer = (state: DateWidgetType, action: Action): DateWidgetType => {
  return featureReducer(state, action);
};
